<div class="trend-graph-main" #page>
    <div style="width: 100%">
        <div>
            <div
                [ngClass]="[
                    'header',
                    responsive.deviceAndOrientation,
                    responsive.screenSize,
                ]"
                [ngStyle]="{
                    margin: isFullscreen() ? '20px 0px 20px 0px' : '',
                }"
            >
                <div class="title-container">
                    <div class="title-wrapper">
                        <div class="lock-option">
                            <mat-icon
                                class="lock-icon"
                                svgIcon="{{ pageAccessIcon }}"
                            >
                            </mat-icon>
                            <div data-cy="trend-graph-access-label">
                                {{
                                    pageAccessTypeTile.concat(
                                        ".",
                                        pageAccessType
                                    ) | translate
                                }}
                            </div>
                        </div>
                        <h1
                            data-cy="trend-graph-title"
                            [ngClass]="[
                                'title',
                                responsive.deviceAndOrientation,
                                responsive.screenSize,
                            ]"
                        >
                            {{ view.name }}
                        </h1>
                    </div>
                </div>
                <div
                    *ngIf="!isFullscreen()"
                    [ngClass]="[
                        'icons-container',
                        responsive.deviceAndOrientation,
                        responsive.screenSize,
                    ]"
                >
                    <app-custom-page-right-buttons
                        class="buttons-wrapper"
                        [usersAccess]="usersAccess"
                        (onShareButtonClick)="changeShareSettings($event)"
                        (onEditButtonClick)="emitEdit($event)"
                        (onDeleteButtonClick)="emitDelete($event)"
                    />
                    <div class="icons-wrapper">
                        <mat-icon
                            data-cy="trend-graph-screenshot-button"
                            svgIcon="screenshot"
                            [ngClass]="['header-icon', responsive.screenSize]"
                            (click)="saveScreenshot()"
                        ></mat-icon>
                        <mat-icon
                            data-cy="trend-graph-download-button"
                            svgIcon="download"
                            [ngClass]="['header-icon', responsive.screenSize]"
                            (click)="onSaveCsvClicked()"
                            [ngStyle]="{ color: !graphHasData() ? 'gray' : '' }"
                        ></mat-icon>
                        <mat-icon
                            data-cy="trend-graph-fullscreen-button"
                            svgIcon="fullscreen"
                            [ngClass]="['header-icon', responsive.screenSize]"
                            (click)="fullscreen()"
                        ></mat-icon>
                    </div>
                </div>
                <div class="icons-container" *ngIf="isFullscreen()">
                    <button
                        data-cy="trend-graph-exit-fullscreen-button"
                        class="exit-fullscreen-button"
                        (click)="exitFullscreen()"
                    >
                        {{ "trend-graph.buttons.exit-fullscreen" | translate }}
                    </button>
                </div>
            </div>

            <app-custom-page-description [text]="view.description" />

            <div style="display: flex">
                <div style="flex: 1">
                    <!-- Graph display region -->
                    <div #graphElement style="position: relative">
                        <app-channel-graph
                            *ngIf="isInitComplete"
                            style="position: relative; left: -25px"
                            #graph
                            (onViewLoaded)="handleGraphLoaded()"
                            [view]="view"
                            [onDataUpdate]="onDataUpdate"
                            [(displayMinXIndex)]="dateRange.startIndex"
                            [(displayMaxXIndex)]="dateRange.endIndex"
                            [displayMinY]="verticalViewRange.start"
                            [displayMaxY]="verticalViewRange.end"
                            [MIN_DATE_INDEX]="MIN_DATE_INDEX"
                            [MAX_DATE_INDEX]="MAX_DATE_INDEX"
                            [graphMinHeight]="graphMinHeight"
                        ></app-channel-graph>

                        <div
                        data-cy="trend-graph-reset-icon"
                            *ngIf="!isAtDefaultZoom()"
                            class="icon-reset"
                            (click)="resetZoom()"
                            style="position: absolute; right: 5px; top: 5px"
                        ></div>
                    </div>
                    <div class="mat-slider-override" style="padding: 0px 15px">
                        <mat-slider
                            data-cy="trend-graph-horizontal-slider"
                            min="{{ MIN_DATE_INDEX }}"
                            max="{{ MAX_DATE_INDEX }}"
                            step="1"
                            style="width: 100%"
                        >
                            <input
                                matSliderStartThumb
                                [(ngModel)]="dateRange.startIndex"
                            />
                            <input
                                matSliderEndThumb
                                [(ngModel)]="dateRange.endIndex"
                            />
                        </mat-slider>
                    </div>
                </div>

                <div class="mat-slider-override vertical-scrollbar-container">
                    <mat-slider
                        data-cy="trend-graph-vertical-slider"
                        subscriptSizing="dynamic"
                        [ngStyle]="{
                            transform: 'rotate(-90deg)',
                            'min-width': verticalSliderHeight + 'px',
                            'margin-bottom': '30px',
                        }"
                        class="vertical-scrollbar"
                        min="{{ MIN_GRAPH_VALUE }}"
                        max="{{ MAX_GRAPH_VALUE }}"
                        step="1"
                    >
                        <input
                            matSliderStartThumb
                            [(ngModel)]="verticalViewRange.start"
                        />
                        <input
                            matSliderEndThumb
                            [(ngModel)]="verticalViewRange.end"
                        />
                    </mat-slider>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Legend click to toggle-->
<div>
    <div
        data-cy="trend-graph-tooltip"
        [ngClass]="[
            'tooltip',
            responsive.deviceAndOrientation,
            responsive.screenSize,
        ]"
    >
        {{ "trend-graph.tooltip.top-graph" | translate }}
    </div>
    <div class="legend-accordion">
        <div
            [ngClass]="[
                'legend-toggle',
                responsive.deviceAndOrientation,
                responsive.screenSize,
            ]"
            (click)="setLegendVisible(!isLegendVisible())"
        >
            <div data-cy="trend-graph-show-or-hide-button">
                {{
                    (isLegendVisible()
                        ? "trend-graph.buttons.hide-legend"
                        : "trend-graph.buttons.show-legend"
                    ) | translate
                }}
            </div>
            <mat-icon
                svgIcon="chevron"
                class="icon-expand"
                [ngClass]="{ closed: !isLegendVisible() }"
            >
            </mat-icon>
        </div>
        <div
            [ngClass]="[
                'legend-tooltip',
                responsive.deviceAndOrientation,
                responsive.screenSize,
            ]"
        >
            {{ "trend-graph.tooltips.legend-entry" | translate }}
        </div>
    </div>
</div>

<!-- Legend -->
<div
    [ngStyle]="{
        height: !isLegendVisible() ? '0' : '',
        padding: !isLegendVisible() ? '0px 15px' : '',
    }"
    [ngClass]="[
        'legend-container',
        responsive.deviceAndOrientation,
        responsive.screenSize,
    ]"
>
    <div
        class="legend-entry"
        *ngFor="let channel of view.channels"
        [ngClass]="{ selected: isSelected(channel) }"
        (click)="
            isSelected(channel)
                ? selectChannel(null)
                : selectChannel(channel.fcuChannelId)
        "
    >
        <div class="color-row">
            <div
                data-cy="trend-graph-variables-channel-color"
                class="color-preview"
                [ngStyle]="{
                    'background-color': isVisible(channel)
                        ? getChannelColor(channel)
                        : '#FFFFFF80',
                }"
            ></div>
            <div
                data-cy="trend-graph-variables-channel"
                class="channel-label"
                [ngStyle]="{
                    color: isVisible(channel) ? 'inherit' : '#FFFFFF80',
                }"
            >
                {{ getLegendLabel(channel) }}
            </div>
        </div>
        <div class="current-value-container">
            <span
                data-cy="trend-graph-variables-current-value-label"
                class="current-value-label"
                >{{ "trend-graph.labels.current-value" | translate }}</span
            >
            <span data-cy="trend-graph-variables-current-value">{{
                getLatestValue(channel.fcuChannelId)
            }}</span>
        </div>
        <div
            data-cy="trend-graph-variables-eye-icon"
            [ngClass]="{
                'icon-watch-on': isVisible(channel),
                'icon-watch-off': !isVisible(channel),
            }"
            (click)="visibilityToggleClicked($event, channel)"
        ></div>
    </div>
</div>

<div *ngIf="shareSettingsOpened" class="share-settings-container">
    <div class="share-settings-wrapper">
        <app-page-share-settings
            [ngClass]="['share-settings', responsive.screenSize]"
            [isPublic]="view.publicAccess"
            [inViewPage]="true"
            [usersAccess]="usersAccess"
            (oncloseSettings)="changeShareSettings($event)"
            (onUpdateUsersAccess)="updateUsersAccess($event)"
            (onUpdatePageAccess)="updatePageAccess($event)"
        >
        </app-page-share-settings>
    </div>
</div>
